'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');

var useHash = function useHash() {
  var _useState = React.useState('#'),
    _useState2 = slicedToArray.default(_useState, 2),
    hash = _useState2[0],
    setHash = _useState2[1];
  React.useEffect(function () {
    var handleHashChange = function handleHashChange() {
      setHash(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return function () {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);
  return hash;
};

exports.default = useHash;
//# sourceMappingURL=useHash.js.map
